import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=b996438c&"
import script from "./messageList.vue?vue&type=script&lang=ts&"
export * from "./messageList.vue?vue&type=script&lang=ts&"
import style0 from "./messageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports